module.exports = __webpack_public_path__ + "static/media/edit-icon-bs.cbb8b3b3.svg";